var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 99,
    viewBox: "0 0 100 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9999 90.7498C27.2176 90.7498 8.74994 72.2821 8.74994 49.4998C8.74994 26.7174 27.2176 8.24976 49.9999 8.24976C72.7823 8.24976 91.2499 26.7174 91.2499 49.4998C91.2499 72.2821 72.7823 90.7498 49.9999 90.7498ZM49.9999 82.4998C58.7521 82.4998 67.1458 79.023 73.3345 72.8343C79.5232 66.6456 82.9999 58.2519 82.9999 49.4998C82.9999 40.7476 79.5232 32.3539 73.3345 26.1652C67.1458 19.9765 58.7521 16.4998 49.9999 16.4998C41.2478 16.4998 32.8541 19.9765 26.6654 26.1652C20.4767 32.3539 16.9999 40.7476 16.9999 49.4998C16.9999 58.2519 20.4767 66.6456 26.6654 72.8343C32.8541 79.023 41.2478 82.4998 49.9999 82.4998ZM45.8873 65.9998L28.3849 48.4974L34.2177 42.6646L45.8873 54.3343L69.2183 30.9991L75.0552 36.8319L45.8873 65.9998Z",
    fill: "url(#paint0_linear_266_5881)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_266_5881",
    x1: 8.74994,
    y1: 53.4114,
    x2: 91.2499,
    y2: 53.4114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BAAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BD8C0"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.41b4ad2ccf97ddc2e86ae3d0b6eb9448.svg";
export { ForwardRef as ReactComponent };